import React from 'react';
import { ClickAwayListener, Paper, Popper, Grow, MenuList, MenuItem } from '@material-ui/core';

function ItemsPopupMenu(props) {
  var anchorEl = props.anchorEl,
      items = props.items,
      onClickAway = props.onClickAway,
      onItemClick = props.onItemClick,
      classes = props.classes;
  if (!anchorEl) return null;
  return React.createElement(Popper, {
    anchorEl: anchorEl,
    open: true,
    role: undefined,
    className: classes.itemsPopupMenu,
    transition: true,
    disablePortal: true
  }, function (_ref) {
    var TransitionProps = _ref.TransitionProps,
        placement = _ref.placement;
    return React.createElement(Grow, Object.assign({}, TransitionProps, {
      style: {
        transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'
      }
    }), React.createElement(Paper, null, React.createElement(ClickAwayListener, {
      onClickAway: onClickAway
    }, React.createElement(MenuList, null, items.map(function (item, index) {
      return React.createElement(MenuItem, {
        onClick: function onClick(event) {
          return onItemClick(event, index);
        },
        key: item.value
      }, item.label);
    })))));
  });
}

export default ItemsPopupMenu;